import root from './root'

const actionType = {
  INFO: '⚑',
  FIRED: '⚡',
  SUCCESS: '✔︎',
  WARN: '⚠︎',
  ERROR: '×'
}

const getStyles = (action) => {
  let msgStyle = ''

  if (action !== actionType.ERROR && action !== actionType.WARN) {
    msgStyle = getStyle({
      isAction: false,
      bg: 'rgba(0,0,0, .5)',
      text: 'white'
    })
  }

  return [getActionStyle(action), msgStyle]
}

const getActionStyle = (action) => {
  switch (action) {
    case actionType.INFO:
      return getStyle({ isAction: true, bg: '#00aaff', text: 'white' })
    case actionType.SUCCESS:
      return getStyle({ isAction: true, bg: 'limegreen', text: 'white' })
    case actionType.FIRED:
        return root.enabled && root.connected
          ? getStyle({ isAction: true, bg: '#00765a', text: 'white' })
          : getStyle({ isAction: true, bg: '#00aaff', text: 'white' })
    default:
      return ''
  }
}

const getStyle = ({ isAction, bg, text }) => {
  return 'height:1.2em;line-height:1.2em;padding:3px 4px;border-top-' + (isAction ? 'left' : 'right') +
    '-radius:3px;border-bottom-' + (isAction ? 'left' : 'right') +
    '-radius:3px;background:' + bg + ';color:' + text + ';'
}

const log = ({ action, actionText, msg, details, force = false }) => {
  logBase({ func: console.log, action, actionText, msg, details, force })
}

const logBase = ({ func, action, actionText, msg, details, force = false }) => {
  if (!root.loggable && !force) {
    return
  }

  let data = ''

  if (details) {
    if (typeof details === 'string') {
      data = details
    } else if (typeof details === 'object') {
      if (Array.isArray(details)) {
        data = Object.assign([], details)
      } else {
        data = Object.assign({}, details)
      }
    }
  }

  let actionBox
  const msgBox = ' %c' + (msg || '')

  if (action !== actionType.ERROR && action !== actionType.WARN) {
    actionBox = '%c' + action + ' ' + actionText
  } else {
    actionBox = actionText
  }

  // In IE11, use standard console.log
  if (document.documentMode) {
    func.apply(console, [actionText, '->', msg || '', data])
  } else {
    func.apply(console, [actionBox + msgBox]
      .concat(getStyles(action), data))
  }
}

const logger = {
  set (data) {
    log({
      action: actionType.SUCCESS,
      actionText: 'data layer updated',
      details: data
    })
  },

  fired (ruleId, details) {
    if (root.connected) {
      log({
        action: actionType.FIRED,
        actionText: 'fired  ',
        msg: ruleId,
        details
      })
    } else {
      log({
        action: actionType.FIRED,
        actionText: 'fired',
        msg: ruleId,
        details
      })
    }
  },

  triggered (pageId, details) {
    log({
      action: actionType.FIRED,
      actionText: 'page view triggered',
      msg: pageId,
      details
    })
  },

  success (actionText, details, data) {
    log({
      action: actionType.SUCCESS,
      actionText,
      msg: details,
      details: data
    })
  },

  info (actionText, details, data) {
    log({
      action: actionType.INFO,
      actionText,
      msg: details,
      details: data
    })
  },

  help (actionText, details, data) {
    log({
      action: actionType.INFO,
      actionText,
      msg: details,
      details: data,
      force: true
    })
  },

  warn (msg) {
    logBase({
      func: console.warn,
      action: actionType.WARN,
      actionText: 'Sanitas Tracker (' + this._app + ')',
      msg
    })
  },

  error (msg) {
    logBase({
      func: console.error,
      action: actionType.ERROR,
      actionText: 'Sanitas Tracker (' + this._app + ')\n',
      msg
    })
  }
}

export default logger
